package ir.yusefpasha.models

enum class Section(
    val id: String,
    val title: String,
    val subTitle: String,
    val path: String
) {
    Home(
        id = "home",
        title = "Home",
        subTitle = "",
        path = "#home"
    ),
    About(
        id = "about",
        title = "About",
        subTitle = "Why Hire Me?",
        path = "#about"
    ),
    Service(
        id = "service",
        title = "Service",
        subTitle = "I`m Good at",
        path = "#service"
    ),
    Portfolio(
        id = "portfolio",
        title = "Portfolio",
        subTitle = "My Work",
        path = "#portfolio"
    ),
    Experience(
        id = "experience",
        title = "Experience",
        subTitle = "My Experience",
        path = "#experience"
    ),
    Contact(
        id = "contact",
        title = "Contact",
        subTitle = "Get In Touch",
        path = "#contact"
    ),
    Testimonial(
        id = "testimonial",
        title = "Testimonial",
        subTitle = "Happy Customers",
        path = "#testimonial"
    ),
    Achievements(
        id = "achievements",
        title = "Achievements",
        subTitle = "Personal Achievements",
        path = "#achievements"
    )
}